import { Alert, Button, FormControlLabel, Stack, Switch, Typography } from "@mui/material";
import { useChecklistQa } from "./ChecklistQaContext";

export default function ChecklistQaToolbar() {
  const qa = useChecklistQa();
  if (qa.error) return <Alert severity="error" action={<Button onClick={qa.reload}>Retry</Button>}>Unable to load QA access and findings.</Alert>;
  if (!qa.access.canViewOrder || qa.loading) return null;
  if (!qa.access.isEligible && !qa.state.notes.length) return null;
  return <Stack spacing={1} sx={{ my: 2 }}>
    <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" useFlexGap>
      <FormControlLabel control={<Switch checked={qa.qaOnly} onChange={(_, value) => qa.setQaOnly(value)} size="small" />} label="Policy QA only" />
      <Typography variant="body2">{qa.state.notes.length} QA finding{qa.state.notes.length === 1 ? "" : "s"}{qa.state.isPending ? " · Pending review" : ""}</Typography>
      <Button variant="outlined" size="small" disabled={!qa.state.isPending || qa.saving || qa.dirty} onClick={qa.review}>
        {qa.saving ? "Saving…" : "QA Reviewed"}
      </Button>
      {qa.dirty && <Typography variant="caption" color="text.secondary">Save or cancel edited notes before reviewing.</Typography>}
    </Stack>
    {qa.state.reviewedAt && <Typography variant="caption" color="text.secondary">
      Last reviewed by {qa.state.reviewedBy} on {new Date(qa.state.reviewedAt).toLocaleString()}{qa.state.isPending ? ". Findings changed since this review." : "."}
    </Typography>}
  </Stack>;
}
